import { useCallback } from 'react';
import { type NavigateFunction, type NavigateOptions, useLocation, useNavigate } from '@direct-frontend/modules-router';

const ABSOLUTE_URL_BASE = 'https://yandex.ru';

export const useNavigateWithSearchParams = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navigateWithSearchParams = useCallback<NavigateFunction>(
        (to, options?: NavigateOptions) => {
            const urlParams = new URLSearchParams(location.search);
            const flagsArgument = urlParams.get('flags');

            if (typeof to === 'number') {
                navigate(to);
            } else if (typeof to === 'string') {
                const url = new URL(to, ABSOLUTE_URL_BASE);
                const toSearch = new URLSearchParams(url.search);

                if (flagsArgument) {
                    toSearch.set('flags', flagsArgument);
                }

                navigate(
                    {
                        pathname: url.pathname,
                        search: toSearch.toString(),
                        hash: url.hash,
                    },
                    options
                );
            } else {
                const toSearch = new URLSearchParams(to.search);

                if (flagsArgument) {
                    toSearch.set('flags', flagsArgument);
                }

                navigate(
                    {
                        ...to,
                        search: toSearch.toString(),
                    },
                    options
                );
            }
        },
        [navigate, location]
    );

    return navigateWithSearchParams;
};
